import { Dialog, DialogRef } from "@angular/cdk/dialog";
import { Injectable } from "@angular/core";
import { DialogComponent } from "../dialog";
import { HelpDialog } from "./model/dialog/form-dialog";

@Injectable({
  providedIn: "root",
})
export class FormFieldModalService {
  constructor(private readonly dialog: Dialog) {}

  tryOpenHelpDialog(
    helpDialog: HelpDialog | undefined,
  ): DialogRef<DialogComponent<HelpDialog>> | undefined {
    if (!helpDialog) {
      return;
    }

    return this.dialog.open<DialogComponent<HelpDialog>>(DialogComponent, {
      width: "clamp(300px, 70%, 600px)",
      height: "auto",
      data: { ...helpDialog, showCloseButton: true },
    });
  }
}
